import { cloneDeep } from "lodash";
import React, { Component } from "react";
import { MdPayment, MdDeleteForever } from "react-icons/md";
import {
  Row,
  Col,
  FormGroup,
  Label,
  Form,
  Table,
  Card,
  Input,
  Button,
  CardHeader,
  CardBody,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  CustomInput,
} from "reactstrap";
import Select from "react-select";
import { CSVLink } from "react-csv";
import NotificationSystem from "react-notification-system";
import { NOTIFICATION_SYSTEM_STYLE } from "../utils/constants";
import * as Server from "../Server";
import Page from "../components/Page";
import moment from "moment";
import PageSpinner from "../components/PageSpinner";

class TeamPlayers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showLoader: false,
      team: this.props.location.state.team,
      TeamPlayers: [],
      headers: [],
      data: [],
      allCamps: [],
      Camps: [],
      Camp: {},
      campDetail: {},
      campPrice: 0,
      selectedPlayer: "",
      removePlayerModal: false,
      paymentConfirmationModal: false,
      notes: "",
      creditAmount: 0,
      creditAmountModal: false,
      processPaymentBalanceModal: false,
      fullPayment: true,
      installments: 0,
      installmentDates: [],
      installmentDateShow: false,
      includeDueAmount: false,
      totalPrice: 0,
      useCreditAmount: false,
      cashPayment: true,
      processPendingEventModal: false,
      creditAmountForEvent: 0,
      dueAmountForEvent: 0,
      selectedCampForCreditAmount: null,
      campsOptions: [],
      creditCards: [],
      allCreditCardOptions: [],
      selectedCreditCard: null,
      csvData: [],
      csvHeaders: [],
      downloadEventCSVModal: false,
      allFields: [],
      selectedFieldsForCSV: [],
      selectFieldsForCSVModal: false,
    };
  }

  componentDidMount() {
    this.getTeamPlayers();
    this.getCamps();
  }

  getTeamPlayers = async () => {
    try {
      this.setState({ showLoader: true });
      let response = await Server.request({
        url: "rushsoccer/teamplayers",
        method: "POST",
        data: {
          teamId: this.props.location.state.team._id,
          CSVFieldsFor: "teamPlayersCSV",
        },
      });
      if (response) {
        let allFields = response.registerForm.reduce(
          (previousValue, currentValue) => {
            previousValue.push(...currentValue.fields);
            return previousValue;
          },
          []
        );
        allFields = allFields
          .filter(
            (allField) =>
              allField.for.value !== "staff" &&
              allField.inputType !== "fileupload" && //remove fileuploads
              allField._id !== "584f8f03-d257-4cf7-b440-9a2a7d730ea3" &&
              allField._id !== "2e3b1830-6147-4955-a3b3-b8e3a2db3d14"
          )
          .map((allField) => ({
            value: allField.for.value,
            label: allField.placeholder,
            key:
              allField.placeholder === "First Name"
                ? "firstName1"
                : allField.placeholder === "Last Name"
                ? "lastName1"
                : allField.keyName,
          }));
        if (allFields.length) {
          allFields.push(
            { label: "Credit Amount", key: "creditAmount" },
            { label: "Due Amount", key: "dueAmount" },
            { label: "Registration Date", key: "registrationDate" },
            { label: "Payment Balance", key: "paymentBalance" },
            { label: "Registered Events", key: "registeredEvents" },
            { label: "Non-Registered Events", key: "nonRegisteredEvents" }
          );
        }
        this.setState({
          showLoader: false,
          TeamPlayers: response.players,
          allFields,
          selectedFieldsForCSV: response.savedCSVFields,
        });
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  removePlayer = async () => {
    try {
      this.setState({ showLoader: true });
      let response = await Server.serverRequest({
        url: "rushUser/player/delete",
        method: "POST",
        data: {
          delete: "child",
          parentId: this.state.selectedPlayer._id,
          childId: this.state.selectedPlayer.child._id,
        },
      });
      if (response && response.success) {
        this.setState({
          showLoader: false,
        });
        this.notificationSystem.addNotification({
          message: response.message,
          level: "success",
        });
        this.getTeamPlayers();
      } else {
        this.setState({
          showLoader: false,
        });
        this.notificationSystem.addNotification({
          message: response.message,
          level: "error",
        });
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  getCamps = async () => {
    try {
      this.setState({ showLoader: true });
      let response = await Server.request({
        url: "camp/web/list",
        method: "GET",
      });
      if (response && response.camps.length > 0) {
        let allCamps = cloneDeep(response.camps);
        allCamps = allCamps.filter(
          (allCamp) =>
            new Date(allCamp.endingAt).getTime() > new Date().getTime() ||
            allCamp.endingAt === null
        );
        let camps = allCamps
          .filter((camp) => camp.selectedPayment === "monthly")
          .filter((camp) => camp.teams.includes(this.state.team._id))
          .map((camp) => ({
            label: camp.name,
            value: camp._id,
          }));
        let allCampsOptions = allCamps.filter((allCamp) =>
          allCamp.teams.includes(this.state.team._id)
        );
        let campsOptions = allCampsOptions.map((camp) => ({
          label: camp.name,
          value: camp._id,
        }));
        this.setState({
          showLoader: false,
          Camps: camps,
          allCamps,
          campsOptions,
        });
      } else {
        this.setState({ showLoader: false });
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  getTeamPlayersForEvent = async () => {
    try {
      if (!this.state.Camp.value) throw Error("Select the event");
      this.setState({ showLoader: true });
      let response = await Server.request({
        url: `rushsoccer/csv/download/teamPlayers/camp?teamId=${this.state.team._id}&eventId=${this.state.Camp.value}`,
        method: "GET",
      });
      if (response) {
        this.setState({
          showLoader: false,
          csvData: response.csvData,
          csvHeaders: response.csvHeaders,
        });
      }
      this.csvLink.link.click();
      this.toggleDownloadEventCSVModal();
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  payForEvent = async () => {
    try {
      let response;
      this.setState({ showLoader: true });
      if (!this.state.Camp.value) throw Error("Select the event");
      if (this.state.cashPayment) {
        response = await Server.request({
          url: "rushsoccer/player/payForEvent",
          method: "POST",
          data: {
            // payForPlayers: true,
            includeDueAmount: this.state.includeDueAmount,
            useCreditAmount: this.state.useCreditAmount,
            note: this.state.notes,
            fullPayment: this.state.fullPayment,
            campId: this.state.Camp.value,
            parentId: this.state.selectedPlayer._id,
            childId: this.state.selectedPlayer.child._id,
            installments: this.state.installments,
            installmentDates: this.state.installmentDates,
            installmentDateShow: this.state.installmentDateShow,
            paymentDoneFrom: "web",
          },
        });
      } else {
        if (!this.state.selectedCreditCard)
          throw Error("Select the credit card for payment");
        let stripeCard = this.state.creditCards.find(
          (creditCard) =>
            creditCard.paymentMethodId === this.state.selectedCreditCard.value
        );
        if (this.state.fullPayment) {
          response = await Server.request({
            url: "rushsoccer/stripe/pay",
            method: "POST",
            data: {
              // payForPlayers: true,
              includeDueAmount: this.state.includeDueAmount,
              useCreditAmount: this.state.useCreditAmount,
              SPIEvent: false,
              sendEmail: false,
              APIVersion: "v2",
              paymentFor: "child",
              campId: this.state.Camp.value,
              paymentMethodId: stripeCard.paymentMethodId,
              parentId: stripeCard.parentId,
              childId: this.state.selectedPlayer.child._id,
              notes: this.state.notes,
              paymentDoneFrom: "web",
            },
          });
        } else {
          response = await Server.request({
            url: "rushsoccer/stripe/interval/pay",
            method: "POST",
            data: {
              payForPlayers: true,
              includeDueAmount: this.state.includeDueAmount,
              useCreditAmount: this.state.useCreditAmount,
              SPIEvent: false,
              sendEmail: false,
              APIVersion: "v2",
              interval: "month",
              paymentFor: "child",
              campId: this.state.Camp.value,
              paymentMethodId: stripeCard.paymentMethodId,
              parentId: stripeCard.parentId,
              childId: this.state.selectedPlayer.child._id,
              notes: this.state.notes,
              installments: this.state.installments,
              installmentDates: this.state.installmentDates,
              installmentDateShow: this.state.installmentDateShow,
              paymentDoneFrom: "web",
            },
          });
        }
      }
      if (response) {
        this.setState({ showLoader: false, selectedCreditCard: null });
        this.notificationSystem.addNotification({
          message: response.message,
          level: "success",
        });
        this.toggleCampPaymentConfirmationModal();
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  processPaymentBalance = async () => {
    try {
      this.setState({ showLoader: true });
      let response = await Server.request({
        url: "rushsoccer/players/processPaymentBalance",
        method: "POST",
        data: {
          users: this.state.TeamPlayers.map((player) => ({
            parentId: player._id,
            childId: player.child._id,
          })),
        },
      });
      if (response) {
        this.setState({ showLoader: false });
        this.notificationSystem.addNotification({
          message: response.message,
          level: "success",
        });
        this.getTeamPlayers();
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  processPendingEvents = async () => {
    try {
      this.setState({ showLoader: true });
      let users = this.state.TeamPlayers.map((player) => {
        let campIds = player.paymentStatus
          .filter((camp) => camp.status === "unpaid")
          .map((camp) => camp.campId);
        return {
          paymentMethodId:
            player.stripeCards && player.stripeCards.length
              ? player.stripeCards[0].paymentMethodId
              : null,
          campIds,
          parentId: player._id,
          childId: player.child._id,
        };
      });
      let response = await Server.request({
        url: "rushsoccer/players/processPendingEvents",
        method: "POST",
        data: { users },
      });
      if (response) {
        this.setState({ showLoader: false });
        this.notificationSystem.addNotification({
          message: response.message,
          level: "success",
        });
        this.getTeamPlayers();
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  addCredit = async (event) => {
    event.preventDefault();
    if (this.state.creditAmount <= 0) {
      this.setState({ creditAmount: 0, notes: "" });
      return this.notificationSystem.addNotification({
        message: "Enter amount greater than zero",
        level: "error",
      });
    } else {
      try {
        this.setState({ showLoader: true });
        let response = await Server.serverRequest({
          url: "rushUser/web/credit",
          method: "POST",
          data: {
            action: "multiplechilds",
            notes: this.state.notes,
            creditAmount: this.state.creditAmount,
            users: this.state.TeamPlayers.map((player) => ({
              parentId: player._id,
              childId: player.child._id,
            })),
            campId: this.state.selectedCampForCreditAmount
              ? this.state.selectedCampForCreditAmount.value
              : null,
            campName: this.state.selectedCampForCreditAmount
              ? this.state.selectedCampForCreditAmount.label
              : null,
          },
        });
        if (response) {
          this.setState({
            notes: "",
            creditAmount: 0,
            showLoader: false,
          });
          this.notificationSystem.addNotification({
            message: response.message,
            level: "success",
          });
          this.toggleCreditModal(event);
          this.getTeamPlayers();
        }
      } catch (error) {
        this.setState({
          notes: "",
          creditAmount: 0,
          showLoader: false,
        });
        this.notificationSystem.addNotification({
          message: error.message,
          level: "error",
        });
      }
    }
  };

  saveCSVFields = async () => {
    try {
      this.setState({ showLoader: true });
      let response = await Server.request({
        url: "rushsoccer/saveCSVFields",
        method: "POST",
        data: {
          CSVFileds: this.state.selectedFieldsForCSV,
          saveCSVFieldsFor: "teamPlayersCSV",
        },
      });
      if (response) {
        this.setState({ showLoader: false });
        this.notificationSystem.addNotification({
          message: response.message,
          level: "success",
        });
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  csvData = async () => {
    if (!this.state.selectedFieldsForCSV.length) {
      this.notificationSystem.addNotification({
        message: "Select atleast one field",
        level: "error",
      });
      return;
    }
    this.setState({ showLoader: true });
    let data = [];
    let headers = this.state.selectedFieldsForCSV;
    for (let index = 0; index < this.state.TeamPlayers.length; index++) {
      const player = this.state.TeamPlayers[index];
      let newData = {};
      for (
        let index1 = 0;
        index1 < this.state.selectedFieldsForCSV.length;
        index1++
      ) {
        const selectedFieldForCSV = this.state.selectedFieldsForCSV[index1];
        if (selectedFieldForCSV.value) {
          if (selectedFieldForCSV.value === "adult") {
            switch (selectedFieldForCSV.key) {
              case "firstName1":
                Object.assign(newData, { firstName1: player.data.firstName });
                break;
              case "lastName1":
                Object.assign(newData, { lastName1: player.data.lastName });
                break;
              default:
                Object.assign(newData, {
                  [selectedFieldForCSV.key]:
                    player.data[selectedFieldForCSV.key] || "-",
                });
                break;
            }
          } else if (selectedFieldForCSV.value === "player") {
            switch (selectedFieldForCSV.key) {
              case "gender":
                let gender = player.child.data.gender
                  ? player.child.data.gender === "Male" ||
                    player.child.data.gender === "male"
                    ? "M"
                    : player.child.data.gender === "Female" ||
                      player.child.data.gender === "female"
                    ? "F"
                    : "-"
                  : "-";
                Object.assign(newData, { gender });
                break;
              case "birthday":
                let birthday = player.child.data.birthday
                  ? moment.utc(player.child.data.birthday).format("MM/DD/YYYY")
                  : "-";
                Object.assign(newData, { birthday });
                break;
              default:
                Object.assign(newData, {
                  [selectedFieldForCSV.key]:
                    player.child.data[selectedFieldForCSV.key] || "-",
                });
                break;
            }
          }
        } else {
          switch (selectedFieldForCSV.key) {
            case "creditAmount":
              let creditAmount = player.child.creditAmount || "0";
              Object.assign(newData, { creditAmount });
              break;
            case "dueAmount":
              let dueAmount = player.child.dueAmount || "0";
              Object.assign(newData, { dueAmount });
              break;
            case "registrationDate":
              let registrationDate = player.child.createdAt
                ? moment.utc(player.child.createdAt).format("MM/DD/YYYY")
                : "-";
              Object.assign(newData, { registrationDate });
              break;
            case "paymentBalance":
              let paymentBalance = player.paymentBalance || "0";
              Object.assign(newData, { paymentBalance });
              break;
            case "registeredEvents":
              let registeredEvents = player.paymentStatus
                .filter((camp) => camp.status === "paid")
                .map((camp) => camp.name);
              registeredEvents = registeredEvents.length
                ? registeredEvents.join(",")
                : registeredEvents;
              Object.assign(newData, { registeredEvents });
              break;
            case "nonRegisteredEvents":
              let nonRegisteredEvents = player.paymentStatus
                .filter((camp) => camp.status === "unpaid")
                .map((camp) => camp.name);
              nonRegisteredEvents = nonRegisteredEvents.length
                ? nonRegisteredEvents.join(",")
                : nonRegisteredEvents;
              Object.assign(newData, { nonRegisteredEvents });
              break;
          }
        }
      }
      data.push(newData);
    }
    this.setState(
      {
        showLoader: false,
        data,
        headers,
      },
      () =>
        setTimeout(() => {
          this.csvLink1.link.click();
          this.toggleSelectFieldsForCSVModal();
        }, 1000)
    );
  };

  renderPlayerDetailPage = async (childId) => {
    this.props.history.push({
      pathname: "/playerDetail",
      state: { childId },
    });
  };

  toggleRemovePlayerModal = () => {
    this.setState({ removePlayerModal: !this.state.removePlayerModal });
  };

  toggleCampPaymentConfirmationModal = (player) => {
    let allCreditCardOptions = player
      ? player.allCreditCards.map((creditCard) => ({
          label: `(${creditCard.name})${creditCard.number}`,
          value: creditCard.paymentMethodId,
        }))
      : [];
    this.setState({
      paymentConfirmationModal: !this.state.paymentConfirmationModal,
      selectedPlayer: player ? player : {},
      Camp: {},
      campPrice: 0,
      notes: "",
      installments: 0,
      fullPayment: true,
      cashPayment: true,
      installmentDates: [],
      installmentDateShow: false,
      includeDueAmount: false,
      useCreditAmount: false,
      totalPrice: 0,
      creditCards: player ? player.allCreditCards || [] : [],
      allCreditCardOptions,
      selectedCreditCard: null,
    });
  };

  toggleCreditModal = (event) => {
    event.preventDefault();
    this.setState({
      creditAmountModal: !this.state.creditAmountModal,
      creditAmount: "",
      notes: "",
      selectedCampForCreditAmount: null,
    });
  };

  toggleProcessPaymentBalanceModal = (event) => {
    event.preventDefault();
    this.setState({
      processPaymentBalanceModal: !this.state.processPaymentBalanceModal,
    });
  };

  toggleProcessPendingEventModal = () => {
    this.setState({
      processPendingEventModal: !this.state.processPendingEventModal,
    });
  };

  toggleDownloadEventCSVModal = () => {
    this.setState({
      Camp: {},
      downloadEventCSVModal: !this.state.downloadEventCSVModal,
    });
  };

  toggleSelectFieldsForCSVModal = () => {
    this.setState({
      selectFieldsForCSVModal: !this.state.selectFieldsForCSVModal,
    });
  };

  handleCampChange = (camp) => {
    if (camp) {
      let selectedCamp = this.state.allCamps.find(
        (allcamp) => allcamp._id === camp.value
      );
      let totalPrice = selectedCamp.price;
      let creditAmount = 0;
      let dueAmount = 0;
      if (this.state.selectedPlayer.child.creditAmountBreakUp.length) {
        let creditAmountBreakUp = this.state.selectedPlayer.child.creditAmountBreakUp.filter(
          (value) =>
            value.campId === selectedCamp._id ||
            !value.campId ||
            value.campId === ""
        );
        creditAmount = creditAmountBreakUp.reduce((preVal, curVal) => {
          preVal += curVal.amount;
          return preVal;
        }, 0);
      }
      if (this.state.selectedPlayer.child.dueAmountBreakUp.length) {
        let dueAmountBreakUp = this.state.selectedPlayer.child.dueAmountBreakUp.filter(
          (value) =>
            value.campId === selectedCamp._id ||
            !value.campId ||
            value.campId === ""
        );
        dueAmount = dueAmountBreakUp.reduce((preVal, curVal) => {
          preVal += curVal.amount;
          return preVal;
        }, 0);
      }
      totalPrice = totalPrice - creditAmount;
      // totalPrice = this.state.includeDueAmount
      //   ? this.state.dueAmountForEvent + totalPrice
      //   : totalPrice;
      this.setState({
        totalPrice,
        Camp: camp,
        campPrice: selectedCamp.price,
        installments: selectedCamp.installments || 0,
        installmentDates: selectedCamp.installmentDates || [],
        installmentDateShow:
          selectedCamp.installmentDates && selectedCamp.installmentDates.length
            ? true
            : false,
        includeDueAmount: false,
        useCreditAmount: true,
        campDetail: selectedCamp,
        creditAmountForEvent: creditAmount,
        dueAmountForEvent: dueAmount,
      });
    } else {
      this.setState({
        totalPrice: 0,
        Camp: {},
        campPrice: 0,
        installments: 0,
        installmentDates: [],
        installmentDateShow: false,
        includeDueAmount: false,
        useCreditAmount: false,
      });
    }
  };

  installmentDates = (key) => {
    let dates =
      this.state.installmentDates.length > 0 ? this.state.installmentDates : [];
    if (key === "add") {
      if (this.state.installmentDates.length !== this.state.installments) {
        let Start =
          this.state.installmentDates.length === 0
            ? 1
            : this.state.installmentDates.length + 1;
        for (let index = Start; index <= this.state.installments; index++) {
          dates.push({ price: 0, date: "", installmentNumber: index });
        }
      }
    } else if (key === "remove") {
      for (
        let index1 = this.state.installments + 1;
        index1 <= this.state.installmentDates.length;
        index1++
      ) {
        dates = dates.filter((date) => date.installmentNumber !== index1);
      }
    }
    this.setState({ installmentDates: dates });
  };

  getTotalPrice = () => {
    let totalPrice = this.state.installmentDates[0].price;
    if (this.state.includeDueAmount)
      totalPrice = totalPrice + this.state.dueAmountForEvent;
    if (this.state.useCreditAmount)
      totalPrice = totalPrice - this.state.creditAmountForEvent;
    return totalPrice > 0 ? totalPrice : 0;
  };

  render() {
    return (
      <div>
        <Page
          title={"Team-Players"}
          breadcrumbs={[{ name: "Team-Players", active: true }]}
        >
          <PageSpinner showLoader={this.state.showLoader} />
          <Card>
            <CardHeader>
              <Row>
                <Col md={6}>
                  <Input
                    className="mt-1"
                    type="text"
                    defaultValue={this.state.team.name}
                    disabled
                  ></Input>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Button
                    className="float-right mt-3"
                    onClick={() => this.toggleDownloadEventCSVModal()}
                  >
                    Download events csv
                  </Button>
                  <CSVLink
                    className="text-white"
                    style={{ textDecoration: "unset" }}
                    filename={`${this.state.team.name}_${this.state.Camp.label}_teamPlayers.csv`}
                    data={this.state.csvData}
                    headers={this.state.csvHeaders}
                    ref={(ref) => {
                      this.csvLink = ref;
                    }}
                  ></CSVLink>
                  <Button
                    className="float-right mr-2 mt-3"
                    onClick={() => this.toggleProcessPendingEventModal()}
                  >
                    Process Pending Events
                  </Button>
                  <Button
                    className="float-right mr-2 mt-3"
                    onClick={() => this.toggleSelectFieldsForCSVModal()}
                  >
                    Download csv
                  </Button>
                  <Button
                    className="float-right mr-2 mt-3"
                    onClick={(event) =>
                      this.toggleProcessPaymentBalanceModal(event)
                    }
                  >
                    Process Payment Balance
                  </Button>
                  <Button
                    className="float-right mr-2 mt-3"
                    onClick={(event) => this.toggleCreditModal(event)}
                  >
                    Add Credit
                  </Button>
                </Col>
              </Row>
            </CardHeader>
            <CardBody>
              <Table striped hover responsive className="border-1">
                <thead>
                  <tr>
                    <th>Photo</th>
                    <th>Name</th>
                    <th>Parent Name</th>
                    <th>Parent Email</th>
                    <th>Parent Phone</th>
                    <th>Credit Amount</th>
                    <th>Due Amount</th>
                    <th>Payment Balance</th>
                    <th>Actions</th>
                    {/* <th>Payment Status</th> */}
                  </tr>
                </thead>
                <tbody>
                  {this.state.TeamPlayers &&
                  this.state.TeamPlayers.length > 0 ? (
                    this.state.TeamPlayers.map((rushuser, index) => (
                      <tr
                        key={index}
                        style={{ cursor: "pointer" }}
                        onClick={() =>
                          this.renderPlayerDetailPage(rushuser.child._id)
                        }
                      >
                        <td>
                          {rushuser.child.data.files &&
                          rushuser.child.data.files.length > 0
                            ? rushuser.child.data.files.map(
                                (file) =>
                                  file.name === "photo" && (
                                    <img
                                      src={file.url}
                                      className="img-responsive"
                                      alt=""
                                      style={{ width: "100px" }}
                                    />
                                  )
                              )
                            : "Not Available"}
                        </td>
                        <td>
                          {rushuser.child.data.firstName +
                            " " +
                            rushuser.child.data.lastName}
                        </td>
                        <td>
                          {rushuser.data.firstName +
                            " " +
                            rushuser.data.lastName}
                        </td>
                        <td>{rushuser.data.email}</td>
                        <td>{rushuser.data.phone}</td>
                        <td>
                          {rushuser.child.creditAmount
                            ? rushuser.child.creditAmount.toFixed(2)
                            : (0).toFixed(2)}
                        </td>
                        <td>
                          {rushuser.child.dueAmount
                            ? rushuser.child.dueAmount.toFixed(2)
                            : (0).toFixed(2)}
                        </td>
                        <td>
                          {rushuser.paymentBalance
                            ? rushuser.paymentBalance.toFixed(2)
                            : (0).toFixed(2)}
                        </td>
                        <td>
                          <Button
                            className="mb-2 mr-2"
                            onClick={(event) => {
                              event.stopPropagation();
                              this.setState({ selectedPlayer: rushuser });
                              this.toggleRemovePlayerModal();
                            }}
                          >
                            <MdDeleteForever size="20px"></MdDeleteForever>
                          </Button>
                          <Button
                            className="mb-2"
                            onClick={(event) => {
                              event.stopPropagation();
                              this.toggleCampPaymentConfirmationModal(rushuser);
                            }}
                          >
                            <MdPayment size="20px"></MdPayment>
                          </Button>
                        </td>
                        {/* <td>{
                            rushuser.paymentStatus && rushuser.paymentStatus.length
                              ? rushuser.paymentStatus.map((camp, index) =>
                                <>
                                  {camp.name}-{camp.status}{rushuser.paymentStatus.length !==
                                    index + 1 && ","} <br />
                                </>
                              )
                              : '-'
                          }</td> */}
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="9" className="text-center">
                        No players Found
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </CardBody>
            {this.state.removePlayerModal ? (
              <Modal
                isOpen={this.state.removePlayerModal}
                toggle={(event) => this.toggleRemovePlayerModal()}
                className="modal-md"
              >
                <ModalHeader toggle={(event) => this.toggleRemovePlayerModal()}>
                  Delete Player
                </ModalHeader>
                <ModalBody>
                  Are you sure you want to delete{" "}
                  {this.state.selectedPlayer.child.data.firstName +
                    " " +
                    this.state.selectedPlayer.child.data.lastName}{" "}
                  ?
                </ModalBody>
                <ModalFooter>
                  <Button
                    color="secondary"
                    onClick={(event) => this.toggleRemovePlayerModal()}
                  >
                    Cancel
                  </Button>
                  <Button
                    color="primary"
                    onClick={(event) => {
                      this.removePlayer();
                      this.toggleRemovePlayerModal();
                    }}
                  >
                    Delete
                  </Button>
                </ModalFooter>
              </Modal>
            ) : null}
            {this.state.paymentConfirmationModal ? (
              <Modal
                isOpen={this.state.paymentConfirmationModal}
                toggle={(event) => this.toggleCampPaymentConfirmationModal()}
                className="modal-md"
              >
                <ModalHeader
                  toggle={(event) => this.toggleCampPaymentConfirmationModal()}
                >
                  Payment for Event
                </ModalHeader>
                <ModalBody>
                  <Row>
                    <Col xl={12} lg={12} md={12}>
                      <FormGroup>
                        <Label>Events:</Label>
                        <Select
                          options={this.state.Camps || []}
                          isSearchable={true}
                          isClearable={true}
                          value={this.state.Camp}
                          onChange={this.handleCampChange}
                          className="basic-single"
                          classNamePrefix="select"
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  {this.state.Camp.value &&
                  this.state.campDetail.includeDueAmount ? (
                    <>
                      <Row>
                        <Col xl={12} lg={12} md={12}>
                          <Label>Include any past due amount:</Label>
                        </Col>
                      </Row>
                      <Row>
                        <Col xl={6} lg={6} md={6} sm={6}>
                          <FormGroup>
                            <CustomInput
                              id="yes"
                              type="radio"
                              label="Yes"
                              checked={this.state.includeDueAmount}
                              name="includeDueAmount"
                              onClick={() => {
                                let totalPrice = this.state.campPrice;
                                if (this.state.quantity)
                                  totalPrice =
                                    this.state.campPrice * this.state.quantity;
                                if (this.state.useCreditAmount)
                                  totalPrice =
                                    totalPrice -
                                    this.state.creditAmountForEvent;
                                totalPrice =
                                  totalPrice + this.state.dueAmountForEvent;
                                this.setState({
                                  totalPrice: totalPrice > 0 ? totalPrice : 0,
                                  includeDueAmount: true,
                                });
                              }}
                            />
                          </FormGroup>
                        </Col>
                        <Col xl={6} lg={6} md={6} sm={6}>
                          <FormGroup>
                            <CustomInput
                              id="no"
                              type="radio"
                              label="No"
                              checked={!this.state.includeDueAmount}
                              name="includeDueAmount"
                              onClick={() => {
                                let totalPrice = this.state.campPrice;
                                if (this.state.quantity)
                                  totalPrice =
                                    this.state.campPrice * this.state.quantity;
                                if (this.state.useCreditAmount)
                                  totalPrice =
                                    totalPrice -
                                    this.state.creditAmountForEvent;
                                this.setState({
                                  totalPrice: totalPrice > 0 ? totalPrice : 0,
                                  includeDueAmount: false,
                                });
                              }}
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                    </>
                  ) : null}
                  {this.state.Camp.value &&
                  this.state.campDetail.useCreditAmount ? (
                    <>
                      <Row>
                        <Col xl={12} lg={12} md={12}>
                          <Label>Use credit amount:</Label>
                        </Col>
                      </Row>
                      <Row>
                        <Col xl={6} lg={6} md={6} sm={6}>
                          <FormGroup>
                            <CustomInput
                              id="yes1"
                              type="radio"
                              label="Yes"
                              checked={this.state.useCreditAmount}
                              name="useCreditAmount"
                              onClick={() => {
                                let totalPrice = this.state.campPrice;
                                if (this.state.quantity)
                                  totalPrice =
                                    this.state.campPrice * this.state.quantity;
                                if (this.state.includeDueAmount)
                                  totalPrice =
                                    totalPrice + this.state.dueAmountForEvent;
                                totalPrice =
                                  totalPrice - this.state.creditAmountForEvent;
                                this.setState({
                                  totalPrice: totalPrice > 0 ? totalPrice : 0,
                                  useCreditAmount: true,
                                });
                              }}
                            />
                          </FormGroup>
                        </Col>
                        <Col xl={6} lg={6} md={6} sm={6}>
                          <FormGroup>
                            <CustomInput
                              id="no1"
                              type="radio"
                              label="No"
                              checked={!this.state.useCreditAmount}
                              name="useCreditAmount"
                              onClick={() => {
                                let totalPrice = this.state.campPrice;
                                if (this.state.quantity)
                                  totalPrice =
                                    this.state.campPrice * this.state.quantity;
                                if (this.state.includeDueAmount)
                                  totalPrice =
                                    totalPrice + this.state.dueAmountForEvent;
                                this.setState({
                                  totalPrice: totalPrice > 0 ? totalPrice : 0,
                                  useCreditAmount: false,
                                });
                              }}
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                    </>
                  ) : null}
                  <Row>
                    <Col xl={12} lg={12} md={12}>
                      <FormGroup>
                        <Label>Event Price</Label>
                        <Input
                          disabled
                          type="text"
                          value={this.state.campPrice}
                        ></Input>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col xl={12} lg={12} md={12}>
                      <FormGroup>
                        <Label>Total Price</Label>
                        <Input
                          disabled
                          type="text"
                          value={this.state.totalPrice}
                        ></Input>
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row>
                    <Col xl={12} lg={12} md={12}>
                      <FormGroup>
                        <Label>Add Note</Label>
                        <Input
                          required
                          type="text"
                          placeholder="Payment done by admin"
                          value={this.state.notes}
                          onChange={(event) => {
                            event.persist();
                            this.setState({
                              notes: event.target.value,
                            });
                          }}
                        ></Input>
                      </FormGroup>
                    </Col>
                  </Row>
                  {this.state.Camp.value && (
                    <>
                      <Row>
                        <Col xl={6} lg={6} md={6} sm={6}>
                          <FormGroup>
                            <CustomInput
                              id="cashpayment"
                              type="radio"
                              label="Cash Payment"
                              checked={this.state.cashPayment}
                              name="payment1"
                              onClick={() =>
                                this.setState({
                                  cashPayment: true,
                                })
                              }
                            />
                          </FormGroup>
                        </Col>
                        <Col xl={6} lg={6} md={6} sm={6}>
                          <FormGroup>
                            <CustomInput
                              id="cardpayment"
                              type="radio"
                              label="Credit card payment"
                              checked={!this.state.cashPayment}
                              name="payment1"
                              onClick={() =>
                                this.setState({
                                  cashPayment: false,
                                })
                              }
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                      {!this.state.cashPayment ? (
                        <Row>
                          <Col xl={12} lg={12} md={12}>
                            <FormGroup>
                              <Label>Select Credit Card</Label>
                              <Select
                                placeholder="Select the credit card"
                                value={this.state.selectedCreditCard}
                                options={this.state.allCreditCardOptions}
                                onChange={(result) =>
                                  this.setState({
                                    selectedCreditCard: result,
                                  })
                                }
                              />
                            </FormGroup>
                          </Col>
                        </Row>
                      ) : null}
                      <Row>
                        <Col xl={6} lg={6} md={6} sm={6}>
                          <FormGroup>
                            <CustomInput
                              id="fullpayment"
                              type="radio"
                              label="Full Payment"
                              checked={this.state.fullPayment}
                              name="payment"
                              onClick={() =>
                                this.setState({
                                  fullPayment: true,
                                })
                              }
                            />
                          </FormGroup>
                        </Col>
                        <Col xl={6} lg={6} md={6} sm={6}>
                          <FormGroup>
                            <CustomInput
                              id="installmentpayment"
                              type="radio"
                              label="Installment payment"
                              checked={!this.state.fullPayment}
                              name="payment"
                              onClick={() =>
                                this.setState({
                                  fullPayment: false,
                                })
                              }
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                    </>
                  )}
                  {!this.state.fullPayment && (
                    <>
                      <Row>
                        <Col xl={12} lg={12} md={12} sm={12}>
                          <FormGroup>
                            <Label for="installments">
                              Select Installments :
                            </Label>
                            <CustomInput
                              type="select"
                              id="installments"
                              name="selectInstallments"
                              defaultValue={"0"}
                              value={this.state.installments}
                              onChange={(event) => {
                                event.persist();
                                let key =
                                  event.target.value >
                                  parseInt(this.state.installments || 0)
                                    ? "add"
                                    : "remove";
                                this.setState(
                                  {
                                    installments: Number(event.target.value),
                                  },
                                  () => this.installmentDates(key)
                                );
                              }}
                            >
                              <option value="0" disabled>
                                Select the value
                              </option>
                              <option value="2">2</option>
                              <option value="3">3</option>
                              <option value="4">4</option>
                              <option value="5">5</option>
                              <option value="6">6</option>
                              <option value="7">7</option>
                              <option value="8">8</option>
                              <option value="9">9</option>
                              <option value="10">10</option>
                              <option value="11">11</option>
                            </CustomInput>
                          </FormGroup>
                        </Col>
                      </Row>
                      {this.state.installments ? (
                        <Row>
                          <Col xl={12} lg={12} md={12} sm={12}>
                            <div className="ml-4">
                              <Input
                                type="checkbox"
                                style={{ width: "15px", height: "15px" }}
                                checked={this.state.installmentDateShow}
                                onChange={async (event) => {
                                  this.setState(
                                    {
                                      installmentDateShow: !this.state
                                        .installmentDateShow,
                                    },
                                    () => {
                                      this.state.installmentDateShow === true &&
                                        this.installmentDates("add");
                                    }
                                  );
                                }}
                              ></Input>
                              <Label>Set Custom Installment Dates</Label>
                            </div>
                          </Col>
                        </Row>
                      ) : null}
                      {this.state.installmentDateShow && (
                        <Row>
                          <Col xl={12} lg={12} md={12} sm={12}>
                            <Label>Installment Dates :</Label>
                            {this.state.installmentDates &&
                            this.state.installmentDates.length > 0
                              ? this.state.installmentDates.map(
                                  (installmentDate, index) => (
                                    <div className="mt-2 mb-3" key={index}>
                                      {index === 0 ? (
                                        <>
                                          <Label>
                                            Payment {index} :
                                            {this.state.cashPayment
                                              ? " (Payment using cash)"
                                              : " (Payment using credit card)"}
                                          </Label>
                                          <Input
                                            type="number"
                                            min="0"
                                            required={
                                              this.state.installmentDateShow
                                            }
                                            value={installmentDate.price}
                                            onChange={(event) => {
                                              // let camp =
                                              this.state.allCamps.find(
                                                (camp) =>
                                                  camp._id ===
                                                  this.state.Camp.value
                                              );
                                              // if (
                                              //   event.target.value >= 0 &&
                                              //   event.target.value <=
                                              //   camp.price
                                              // ) {
                                              let installmentDates = cloneDeep(
                                                this.state.installmentDates
                                              );
                                              installmentDates[
                                                index
                                              ].price = Number(
                                                event.target.value
                                              );
                                              this.setState({
                                                installmentDates: installmentDates,
                                              });
                                              // }
                                            }}
                                          ></Input>
                                          {this.state.includeDueAmount ? (
                                            <div className="mt-2 mb-3">
                                              <Label>Due Amount :</Label>
                                              <Input
                                                type="number"
                                                disabled
                                                value={
                                                  this.state.selectedPlayer
                                                    .child.dueAmount
                                                }
                                              ></Input>
                                            </div>
                                          ) : null}
                                          {this.state.useCreditAmount ? (
                                            <div className="mt-2 mb-3">
                                              <Label>Credit Amount :</Label>
                                              <Input
                                                type="number"
                                                disabled
                                                value={
                                                  this.state.selectedPlayer
                                                    .child.creditAmount
                                                }
                                              ></Input>
                                            </div>
                                          ) : null}
                                          {this.state.includeDueAmount ||
                                          this.state.useCreditAmount ? (
                                            <div className="mt-2 mb-3">
                                              <Label>Total Price :</Label>
                                              <Input
                                                type="number"
                                                disabled
                                                value={this.getTotalPrice()}
                                              ></Input>
                                            </div>
                                          ) : null}
                                        </>
                                      ) : (
                                        <>
                                          <Label>
                                            Payment {index} : (Payment using
                                            credit card)
                                          </Label>
                                          <Input
                                            type="date"
                                            value={
                                              moment(
                                                new Date(installmentDate.date)
                                              ).format("YYYY-MM-DD") || ""
                                            }
                                            onChange={(event) => {
                                              let dates = this.state
                                                .installmentDates;
                                              let date = new Date(
                                                event.target.value
                                              ).setUTCHours(12);
                                              dates[index].date = date;
                                              this.setState({
                                                installmentDates: dates,
                                              });
                                            }}
                                            required={
                                              this.state.installmentDateShow
                                            }
                                          ></Input>
                                        </>
                                      )}
                                    </div>
                                  )
                                )
                              : null}
                          </Col>
                        </Row>
                      )}
                    </>
                  )}
                </ModalBody>
                <ModalFooter>
                  <Button
                    color="secondary"
                    onClick={(event) =>
                      this.toggleCampPaymentConfirmationModal()
                    }
                  >
                    Cancel
                  </Button>
                  <Button
                    color="primary"
                    onClick={(event) => {
                      this.payForEvent();
                    }}
                  >
                    Pay
                  </Button>
                </ModalFooter>
              </Modal>
            ) : null}
            {this.state.creditAmountModal ? (
              <Modal
                isOpen={this.state.creditAmountModal}
                toggle={(event) => this.toggleCreditModal(event)}
                className="modal-md"
              >
                <ModalHeader toggle={(event) => this.toggleCreditModal(event)}>
                  <Label>Add credit to all players</Label>
                </ModalHeader>
                <Form onSubmit={(event) => this.addCredit(event)}>
                  <ModalBody>
                    <Row>
                      <Col xl={12} lg={12} md={12}>
                        <FormGroup>
                          <Label>Amount</Label>
                          <Input
                            type="number"
                            placeholder="Enter Amount"
                            value={this.state.creditAmount}
                            onChange={(event) =>
                              event.target.value >= 0
                                ? this.setState({
                                    creditAmount: Number(event.target.value),
                                  })
                                : null
                            }
                            required
                          ></Input>
                        </FormGroup>
                      </Col>
                      <Col xl={12} lg={12} md={12}>
                        <FormGroup>
                          <Label>Add Note</Label>
                          <Input
                            required
                            type="text"
                            placeholder="Add Note"
                            value={this.state.notes}
                            onChange={(event) => {
                              event.persist();
                              this.setState({
                                notes: event.target.value,
                              });
                            }}
                          ></Input>
                        </FormGroup>
                      </Col>
                      <Col xl={12} lg={12} md={12}>
                        <FormGroup>
                          <Label>Select Event</Label>
                          <Select
                            isSearchable={false}
                            placeholder="Select the event"
                            value={this.state.selectedCampForCreditAmount}
                            options={this.state.campsOptions}
                            onChange={(result) =>
                              this.setState({
                                selectedCampForCreditAmount: result,
                              })
                            }
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                  </ModalBody>
                  <ModalFooter>
                    <Button type="submit">Submit</Button>
                    <Button
                      color="secondary"
                      onClick={(event) => this.toggleCreditModal(event)}
                    >
                      Cancel
                    </Button>
                  </ModalFooter>
                </Form>
              </Modal>
            ) : null}
            {this.state.processPaymentBalanceModal ? (
              <Modal
                isOpen={this.state.processPaymentBalanceModal}
                toggle={(event) => this.toggleProcessPaymentBalanceModal(event)}
                className="modal-md"
              >
                <ModalHeader
                  toggle={(event) =>
                    this.toggleProcessPaymentBalanceModal(event)
                  }
                >
                  <Label>Process Payment Balance</Label>
                </ModalHeader>
                <ModalBody>
                  Are you sure you want to process payment balance ?
                </ModalBody>
                <ModalFooter>
                  <Button
                    color="primary"
                    onClick={(event) => {
                      this.processPaymentBalance(event);
                      this.toggleProcessPaymentBalanceModal(event);
                    }}
                  >
                    Process
                  </Button>
                  <Button
                    color="secondary"
                    onClick={(event) =>
                      this.toggleProcessPaymentBalanceModal(event)
                    }
                  >
                    Cancel
                  </Button>
                </ModalFooter>
              </Modal>
            ) : null}
            {this.state.processPendingEventModal ? (
              <Modal
                isOpen={this.state.processPendingEventModal}
                toggle={() => this.toggleProcessPendingEventModal()}
                className="modal-md"
              >
                <ModalHeader
                  toggle={() => this.toggleProcessPendingEventModal()}
                >
                  <Label>Process Pending Events</Label>
                </ModalHeader>
                <ModalBody>
                  Are you sure you want to process pending events ?
                </ModalBody>
                <ModalFooter>
                  <Button
                    color="primary"
                    onClick={() => {
                      this.processPendingEvents();
                      this.toggleProcessPendingEventModal();
                    }}
                  >
                    Process
                  </Button>
                  <Button
                    color="secondary"
                    onClick={(event) => this.toggleProcessPendingEventModal()}
                  >
                    Cancel
                  </Button>
                </ModalFooter>
              </Modal>
            ) : null}
            {this.state.downloadEventCSVModal ? (
              <Modal
                isOpen={this.state.downloadEventCSVModal}
                toggle={(event) => this.toggleDownloadEventCSVModal()}
                className="modal-md"
              >
                <ModalHeader
                  toggle={(event) => this.toggleDownloadEventCSVModal()}
                >
                  Download CSV
                </ModalHeader>
                <ModalBody>
                  <Row>
                    <Col xl={12} lg={12} md={12}>
                      <FormGroup>
                        <Label>Events:</Label>
                        <Select
                          options={this.state.Camps || []}
                          isSearchable={true}
                          value={this.state.Camp}
                          onChange={(result) => {
                            this.setState({
                              Camp: result || {},
                            });
                          }}
                          className="basic-single"
                          classNamePrefix="select"
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                </ModalBody>
                <ModalFooter>
                  <Button
                    color="secondary"
                    onClick={(event) => this.toggleDownloadEventCSVModal()}
                  >
                    Cancel
                  </Button>
                  <Button
                    color="primary"
                    onClick={(event) => {
                      this.getTeamPlayersForEvent();
                    }}
                  >
                    Download
                  </Button>
                </ModalFooter>
              </Modal>
            ) : null}
            {this.state.selectFieldsForCSVModal ? (
              <Modal
                isOpen={this.state.selectFieldsForCSVModal}
                toggle={(event) => this.toggleSelectFieldsForCSVModal()}
                className="modal-md"
              >
                <ModalHeader
                  toggle={(event) => this.toggleSelectFieldsForCSVModal()}
                >
                  Select fields for CSV
                </ModalHeader>
                <ModalBody>
                  <Row>
                    {this.state.allFields.length ? (
                      this.state.allFields.map((allField, index) => (
                        <Col md={6} key={index}>
                          <FormGroup>
                            <CustomInput
                              type="checkbox"
                              id={allField.key}
                              label={allField.label}
                              checked={
                                this.state.selectedFieldsForCSV.find(
                                  (selectedFieldForCSV) =>
                                    selectedFieldForCSV.key === allField.key
                                )
                                  ? true
                                  : false
                              }
                              onChange={(event) => {
                                let index = this.state.selectedFieldsForCSV.findIndex(
                                  (selectedFieldForCSV) =>
                                    selectedFieldForCSV.key === allField.key
                                );
                                let selectedFieldsForCSV = cloneDeep(
                                  this.state.selectedFieldsForCSV
                                );
                                if (index !== -1) {
                                  selectedFieldsForCSV.splice(index, 1);
                                } else {
                                  selectedFieldsForCSV.push(allField);
                                }
                                this.setState({ selectedFieldsForCSV });
                              }}
                            />
                          </FormGroup>
                        </Col>
                      ))
                    ) : (
                      <Table
                        striped
                        hover
                        responsive
                        style={{ marginBottom: 0 }}
                      >
                        <tbody>
                          <tr>
                            <td className="text-center">Fields not found</td>
                          </tr>
                        </tbody>
                      </Table>
                    )}
                  </Row>
                </ModalBody>
                <ModalFooter>
                  <Button
                    color="secondary"
                    onClick={(event) => this.toggleSelectFieldsForCSVModal()}
                  >
                    Cancel
                  </Button>
                  <Button color="primary" onClick={() => this.saveCSVFields()}>
                    Save fields
                  </Button>
                  <Button color="primary" onClick={() => this.csvData()}>
                    Download
                  </Button>
                  <CSVLink
                    style={{ textDecoration: "unset" }}
                    filename={`${this.state.team.name}_teamPlayers.csv`}
                    data={this.state.data}
                    headers={this.state.headers}
                    ref={(ref) => {
                      this.csvLink1 = ref;
                    }}
                  ></CSVLink>
                </ModalFooter>
              </Modal>
            ) : null}
          </Card>
          <NotificationSystem
            dismissible={false}
            ref={(notificationSystem) =>
              (this.notificationSystem = notificationSystem)
            }
            style={NOTIFICATION_SYSTEM_STYLE}
          />
        </Page>
      </div>
    );
  }
}

export default TeamPlayers;
